// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toast-container > div {
  opacity: 1;
}

.toast {
  opacity: 1 !important;
}

.category-item {
  color: #000;
}
.category-item:hover {
  color: #e55b00;
}

.active-cat,
.active-cat:hover,
.active-cat > a {
  color: #e55b00 !important;
}

.active-cat,
.category-chart-list > a:hover {
  color: #e55b00;
}

.category-chart-list > a {
  cursor: pointer;
}

.version-button-selection {
  background-color: #e55b00;
}

.search-container:before,
.search-container:after {
  content: "";
  display: table;
  clear: both;
}

.search-container .search-sidebar {
  float: left;
  padding: 15px;
  border: 1px solid #ccd0d4;
  background: #ffffff;
  border-radius: 3px;
  font-size: 12px;
  color: #707478;
}

.search-container .search-sidebar .title {
  margin: -15px -15px 15px;
  padding: 10px 15px;
  border-bottom: 1px solid #ccd0d4;
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.search-container .search-content {
  float: right;
  width: 75%;
  padding-left: 30px;
}

.control-label {
  font-weight: 500;
}

.dbc-btn-primary {
  background: #e55b00;
  color: #ffffff !important;
}
.dbc-btn-primary:not([disabled]):hover {
  background: #e55b00;
  color: #333 !important;
}

.dbc-btn-secondary {
  background: #2d353c;
  color: #ffffff !important;
}
.dbc-btn-secondary:not([disabled]):hover {
  background: #2d353c;
  color: #e55b00 !important;
}

.dbc-link-primary {
  color: #ffffff !important;
}
.dbc-link-primary:not([disabled]):hover {
  color: #e55b00 !important;
}

.img-responsive,
.thumbnail > img,
.thumbnail a > img,
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  width: 100%;
}

.mainItemLine:hover {
  border: 1px solid orange;
}

.item.item-thumbnail .item-title,
.item.item-thumbnail .item-title a {
  font-weight: 600;
  color: #212121;
  font-size: 14px;
  line-height: 18px;
  max-height: 36px;
  overflow: hidden;
}

.item.item-thumbnail .item-discount-price {
  font-size: 14px;
}

.item.item-thumbnail .item-image {
  height: 130px;
  text-align: center;
  padding: 15px;
  line-height: 100px;
  display: block;
  position: relative;
}

.item.item-thumbnail .item-image .discount {
  position: absolute;
  bottom: 0;
  right: 15px;
  line-height: 20px;
  padding: 2px 10px;
  color: #ffffff;
  background: #2d353c;
  font-weight: 600;
  font-size: 13px;
}

.item.item-thumbnail .item-image img {
  max-width: 100%;
  max-height: 100%;
}

.item.item-thumbnail .item-info {
  padding: 15px;
  text-align: center;
}

.category-item.full .item .item-info.top {
  bottom: auto;
  top: 0;
}

.category-item.full .item .item-info.bottom {
  top: auto;
  bottom: 0;
}

.category-item.full .item .item-info {
  padding: 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  color: rgba(255, 255, 255, 0.75);
}

.category-item.full .item .item-info a {
  color: #ffffff;
}

.item.item-thumbnail .item-title {
  margin: 0 0 3px;
}

.item.item-thumbnail .item-title a:hover,
.item.item-thumbnail .item-title a:focus {
  color: #009688;
}

.category-item.full .item .item-title {
  margin: 0 0 5px;
  font-size: 16px;
  line-height: 22px;
}

.item.item-thumbnail .item-desc {
  margin: 0;
  font-size: 12px;
  color: #707478;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-discount .discount {
  font-size: 16px;
  font-weight: 600;
  text-decoration: line-through;
  color: #707478;
}

.product-discount .save {
  margin-left: 10px;
  color: #707478;
  position: relative;
  top: -1px;
}

.item.item-thumbnail .item-price {
  margin: 3px 0;
  font-size: 16px;
  color: #009688;
  font-weight: 600;
}

.animated {
  animation-duration: 0.6s;
  animation-fill-mode: both;
}

.item.item-thumbnail {
  border-radius: 3px;
  border: 1px solid #c5ced4;
  width: 100%;
}

.sort-list > li > span.seperator {
  color: #999;
  margin-left: 8px;
}

.search-toolbar {
  background: #ffffff;
  border: 1px solid #ccd0d4;
  border-radius: 3px;
  padding: 15px;
  margin-bottom: 15px;
}

.search-toolbar:before,
.search-toolbar:after {
  content: "";
  display: table;
  clear: both;
}

.search-toolbar h4 {
  font-size: 12px;
  line-height: 20px;
  margin: 0;
}

.search-toolbar .sort-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 20px;
}

.search-toolbar .sort-list > li {
  display: inline;
}

.search-toolbar .sort-list > li.text {
  font-weight: bold;
}

.search-toolbar .sort-list > li + li {
  margin-left: 10px;
}

.search-toolbar .sort-list > li a {
  color: #999;
  text-decoration: none;
}

.search-toolbar .sort-list > li a:hover,
.search-toolbar .sort-list > li a:focus {
  color: #444;
}

.search-toolbar .sort-list > li.active a,
.search-toolbar .sort-list > li.active a:hover,
.search-toolbar .sort-list > li.active a:focus {
  color: #212121;
}

.input-sm {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

.search-category-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.search-category-list > li > a {
  color: #444;
  font-weight: 600;
  display: block;
  padding: 8px 0px;
  line-height: 20px;
}

.search-category-list > li > a:hover,
.search-category-list > li > a:focus {
  text-decoration: none;
}

.search-category-list > li + li {
  border-top: 1px solid #eee;
}

.price-input {
  max-width: 5rem;
}

.price-to-div {
  max-width: 1rem;
  margin-left: 0.25rem;
  margin-right: -0.35rem;
}

.form-group {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/modals/product-preview-modal/product-preview-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;AAAI;EACI,cAAA;AAER;;AAEA;;;EAGI,yBAAA;AACJ;;AAEA;;EAEI,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;;EAEI,WAAA;EACA,cAAA;EACA,WAAA;AACJ;;AACA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EAGA,kBAAA;EACA,eAAA;EACA,cAAA;AAEJ;;AAAA;EACI,wBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGJ;;AADA;EACI,YAAA;EACA,UAAA;EACA,kBAAA;AAIJ;;AADA;EACI,gBAAA;AAIJ;;AAqBA;EAfI,mBAgBoB;EAfpB,yBAAA;AAFJ;AALI;EASI,mBAakC;EAZlC,sBAAA;AADR;;AAgBA;EAnBI,mBAoBoB;EAnBpB,yBAAA;AAOJ;AAdI;EASI,mBAiBkC;EAhBlC,yBAAA;AAQR;;AAWA;EAdI,yBAAA;AAOJ;AAtBI;EAiBI,yBAAA;AAQR;;AAQA;;;;;EAKI,WAAA;AALJ;;AAQA;EACI,wBAAA;AALJ;;AAQA;;EAEI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AALJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAJJ;;AAMA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAHJ;;AAKA;EACI,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,MAAA;AAFJ;;AAIA;EACI,SAAA;EACA,SAAA;AADJ;;AAIA;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAGA;EACI,eAAA;AAAJ;;AAEA;;EAEI,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,SAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AACJ;;AACA;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAEJ;;AACA;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAEJ;;AACA;EAEI,wBAAA;EAEA,yBAAA;AAEJ;;AACA;EAGI,kBAAA;EACA,yBAAA;EACA,WAAA;AAEJ;;AACA;EACI,WAAA;EACA,gBAAA;AAEJ;;AACA;EACI,mBAAA;EACA,yBAAA;EAGA,kBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;;AAAA;;EAEI,WAAA;EACA,cAAA;EACA,WAAA;AAGJ;;AADA;EACI,eAAA;EACA,iBAAA;EACA,SAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,eAAA;AAMJ;;AAJA;EACI,iBAAA;AAOJ;;AALA;EACI,iBAAA;AAQJ;;AANA;EACI,WAAA;EACA,qBAAA;AASJ;;AAPA;;EAEI,WAAA;AAUJ;;AARA;;;EAGI,cAAA;AAWJ;;AARA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAWJ;;AARA;;EAEI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAWJ;;AARA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AAWJ;;AATA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAYJ;;AAVA;;EAEI,qBAAA;AAaJ;;AAXA;EACI,0BAAA;AAcJ;;AAXA;EACI,eAAA;AAcJ;;AAXA;EACI,eAAA;EACA,oBAAA;EACA,sBAAA;AAcJ;;AAXA;EACI,mBAAA;AAcJ","sourcesContent":["#toast-container > div {\n    opacity: 1;\n}\n\n.toast {\n    opacity: 1 !important;\n}\n\n.category-item {\n    color: #000;\n    &:hover {\n        color: #e55b00;\n    }\n}\n\n.active-cat,\n.active-cat:hover,\n.active-cat > a {\n    color: #e55b00 !important;\n}\n\n.active-cat,\n.category-chart-list > a:hover {\n    color: #e55b00;\n}\n\n.category-chart-list > a {\n    cursor: pointer;\n}\n\n.version-button-selection {\n    background-color: #e55b00;\n}\n\n.search-container:before,\n.search-container:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.search-container .search-sidebar {\n    float: left;\n    padding: 15px;\n    border: 1px solid #ccd0d4;\n    background: #ffffff;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-size: 12px;\n    color: #707478;\n}\n.search-container .search-sidebar .title {\n    margin: -15px -15px 15px;\n    padding: 10px 15px;\n    border-bottom: 1px solid #ccd0d4;\n    font-size: 14px;\n    font-weight: 600;\n    color: #212121;\n}\n.search-container .search-content {\n    float: right;\n    width: 75%;\n    padding-left: 30px;\n}\n\n.control-label {\n    font-weight: 500;\n}\n\n@mixin dbc-hover {\n    &:not([disabled]):hover {\n        @content;\n    }\n}\n\n@mixin dbc-button($background, $color, $hover-background, $hover-color) {\n    background: $background;\n    color: $color !important;\n    @include dbc-hover {\n        background: $hover-background;\n        color: $hover-color !important;\n    }\n}\n\n@mixin dbc-link($color, $hover-color) {\n    color: $color !important;\n    @include dbc-hover {\n        color: $hover-color !important;\n    }\n}\n\n.dbc-btn-primary {\n    @include dbc-button(#e55b00, #ffffff, #e55b00, #333);\n}\n\n.dbc-btn-secondary {\n    @include dbc-button(#2d353c, #ffffff, #2d353c, #e55b00);\n}\n\n.dbc-link-primary {\n    @include dbc-link(#ffffff, #e55b00);\n}\n\n.img-responsive,\n.thumbnail > img,\n.thumbnail a > img,\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n    width: 100%;\n}\n\n.mainItemLine:hover {\n    border: 1px solid orange;\n}\n\n.item.item-thumbnail .item-title,\n.item.item-thumbnail .item-title a {\n    font-weight: 600;\n    color: #212121;\n    font-size: 14px;\n    line-height: 18px;\n    max-height: 36px;\n    overflow: hidden;\n}\n.item.item-thumbnail .item-discount-price {\n    font-size: 14px;\n}\n\n.item.item-thumbnail .item-image {\n    height: 130px;\n    text-align: center;\n    padding: 15px;\n    line-height: 100px;\n    display: block;\n    position: relative;\n}\n.item.item-thumbnail .item-image .discount {\n    position: absolute;\n    bottom: 0;\n    right: 15px;\n    line-height: 20px;\n    padding: 2px 10px;\n    color: #ffffff;\n    background: #2d353c;\n    font-weight: 600;\n    font-size: 13px;\n}\n.item.item-thumbnail .item-image img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.item.item-thumbnail .item-info {\n    padding: 15px;\n    text-align: center;\n}\n\n.category-item.full .item .item-info.top {\n    bottom: auto;\n    top: 0;\n}\n.category-item.full .item .item-info.bottom {\n    top: auto;\n    bottom: 0;\n}\n\n.category-item.full .item .item-info {\n    padding: 20px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1020;\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.category-item.full .item .item-info a {\n    color: #ffffff;\n}\n.item.item-thumbnail .item-title {\n    margin: 0 0 3px;\n}\n.item.item-thumbnail .item-title a:hover,\n.item.item-thumbnail .item-title a:focus {\n    color: #009688;\n}\n\n.category-item.full .item .item-title {\n    margin: 0 0 5px;\n    font-size: 16px;\n    line-height: 22px;\n}\n\n.item.item-thumbnail .item-desc {\n    margin: 0;\n    font-size: 12px;\n    color: #707478;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.product-discount .discount {\n    font-size: 16px;\n    font-weight: 600;\n    text-decoration: line-through;\n    color: #707478;\n}\n.product-discount .save {\n    margin-left: 10px;\n    color: #707478;\n    position: relative;\n    top: -1px;\n}\n\n.item.item-thumbnail .item-price {\n    margin: 3px 0;\n    font-size: 16px;\n    color: #009688;\n    font-weight: 600;\n}\n\n.animated {\n    -webkit-animation-duration: 0.6s;\n    animation-duration: 0.6s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n.item.item-thumbnail {\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    border: 1px solid #c5ced4;\n    width: 100%;\n}\n\n.sort-list > li > span.seperator {\n    color: #999;\n    margin-left: 8px;\n}\n\n.search-toolbar {\n    background: #ffffff;\n    border: 1px solid #ccd0d4;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    padding: 15px;\n    margin-bottom: 15px;\n}\n.search-toolbar:before,\n.search-toolbar:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.search-toolbar h4 {\n    font-size: 12px;\n    line-height: 20px;\n    margin: 0;\n}\n.search-toolbar .sort-list {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    font-size: 12px;\n    line-height: 20px;\n}\n.search-toolbar .sort-list > li {\n    display: inline;\n}\n.search-toolbar .sort-list > li.text {\n    font-weight: bold;\n}\n.search-toolbar .sort-list > li + li {\n    margin-left: 10px;\n}\n.search-toolbar .sort-list > li a {\n    color: #999;\n    text-decoration: none;\n}\n.search-toolbar .sort-list > li a:hover,\n.search-toolbar .sort-list > li a:focus {\n    color: #444;\n}\n.search-toolbar .sort-list > li.active a,\n.search-toolbar .sort-list > li.active a:hover,\n.search-toolbar .sort-list > li.active a:focus {\n    color: #212121;\n}\n\n.input-sm {\n    height: 30px;\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px;\n}\n\n.btn-sm,\n.btn-group-sm > .btn {\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px;\n}\n\n.search-category-list {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n.search-category-list > li > a {\n    color: #444;\n    font-weight: 600;\n    display: block;\n    padding: 8px 0px;\n    line-height: 20px;\n}\n.search-category-list > li > a:hover,\n.search-category-list > li > a:focus {\n    text-decoration: none;\n}\n.search-category-list > li + li {\n    border-top: 1px solid #eee;\n}\n\n.price-input {\n    max-width: 5rem;\n}\n\n.price-to-div {\n    max-width: 1rem;\n    margin-left: 0.25rem;\n    margin-right: -0.35rem;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
